export class QuizAnswer {
  ID: number;
  Answer: string;
  IsCorrect: boolean;
  Rank: number;
  ParentQuestionID: number;
}
